/**
 * Returns the URL only if it is safe to use as an `href`.
 * Allows: http(s)://, mailto:, tel:, fragment (#...), and same-origin paths (/...).
 * Blocks: javascript:, data:, vbscript:, and any other scheme — common stored-XSS vectors.
 */
export function safeHref(url: string | null | undefined, fallback = '#'): string {
  if (!url) return fallback;
  const trimmed = url.trim();
  if (!trimmed) return fallback;

  // Same-origin path or fragment
  if (trimmed.startsWith('#')) return trimmed;
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return trimmed;

  // Allowed schemes
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^mailto:/i.test(trimmed)) return trimmed;
  if (/^tel:/i.test(trimmed)) return trimmed;

  // Anything else (javascript:, data:, vbscript:, file:, protocol-relative //) -> blocked
  return fallback;
}
